import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';

import { LISTING_STATE_DRAFT } from '../../util/types';
import { ensureListing } from '../../util/data';
import { EditListingSkillsForm } from '../../forms';
import { ListingLink } from '..';

import css from './EditListingTimeSlotPanel.module.css';
import EditListingTimeSlotForm from '../../forms/EditListingTimeSlotForm/EditListingTimeSlotForm';

const PREFERENCE_NAME = 'timeSlot';

const EditListingTimeSlotPanel = props => {
  const {
    rootClassName,
    className,
    listing,
    disabled,
    ready,
    onSubmit,
    onChange,
    submitButtonText,
    panelUpdated,
    updateInProgress,
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const currentListing = ensureListing(listing);
  const { publicData } = currentListing.attributes;
  const [errors, setErrors] = useState(false);

  const isPublished = currentListing.id && currentListing.attributes.state !== LISTING_STATE_DRAFT;
  const panelTitle = isPublished ? (
    <FormattedMessage
      id="EditListingTimeSlotPanel.title"
      values={{
        listingTitle: (
          <ListingLink listing={listing}>
            <FormattedMessage id="EditListingTimeSlotPanel.listingTitle" />
          </ListingLink>
        ),
      }}
    />
  ) : (
    <FormattedMessage id="EditListingTimeSlotPanel.createListingTitle" />
  );

  const timeSlot = publicData && publicData.timeSlot;
  const initialValues = { timeSlot };

  return (
    <div className={classes}>
      <h1 className={css.title}>{panelTitle}</h1>
      <EditListingTimeSlotForm
        className={css.form}
        name={PREFERENCE_NAME}
        initialValues={initialValues}
        onSubmit={values => {
          const { timeSlot = [] } = values;

          const updatedValues = {
            publicData: { timeSlot },
          };
          if (timeSlot.length > 0) {
            onSubmit(updatedValues);
            setErrors(false);
          } else {
            setErrors('EditListingPanel.validation.RequiresMinOne');
          }
        }}
        onChange={onChange}
        saveActionMsg={submitButtonText}
        disabled={disabled}
        ready={ready}
        updated={panelUpdated}
        updateInProgress={updateInProgress}
        fetchErrors={errors && <FormattedMessage id={errors} />}
      />
    </div>
  );
};

EditListingTimeSlotPanel.defaultProps = {
  rootClassName: null,
  className: null,
  listing: null,
};

const { bool, func, object, string } = PropTypes;

EditListingTimeSlotPanel.propTypes = {
  rootClassName: string,
  className: string,

  // We cannot use propTypes.listing since the listing might be a draft.
  listing: object,

  disabled: bool.isRequired,
  ready: bool.isRequired,
  onSubmit: func.isRequired,
  onChange: func.isRequired,
  submitButtonText: string.isRequired,
  panelUpdated: bool.isRequired,
  updateInProgress: bool.isRequired,
  errors: object.isRequired,
};

export default EditListingTimeSlotPanel;
